export const args = {
    date: {
        title: 'Date',
        placeholder: 'DD',
        value: '',
    },
    year: {
        title: 'Year',
        placeholder: 'YYYY',
        value: '',
    },
    month: {
        title: 'Month',
        placeholder: 'MM',
        value: '',
    },
};
export const argTypes = {};
